/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_Elbow_LInputs */

const en_us2_bodymap_region_elbow_l = /** @type {(inputs: Bodymap_Region_Elbow_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left elbow`)
};

const pt_br2_bodymap_region_elbow_l = /** @type {(inputs: Bodymap_Region_Elbow_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cotovelo esquerdo`)
};

const es_419_bodymap_region_elbow_l = /** @type {(inputs: Bodymap_Region_Elbow_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codo izquierdo`)
};

const pt_pt2_bodymap_region_elbow_l = /** @type {(inputs: Bodymap_Region_Elbow_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cotovelo esquerdo`)
};

const fr_fr2_bodymap_region_elbow_l = /** @type {(inputs: Bodymap_Region_Elbow_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coude gauche`)
};

const de_de2_bodymap_region_elbow_l = /** @type {(inputs: Bodymap_Region_Elbow_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linker Ellbogen`)
};

const it_it2_bodymap_region_elbow_l = /** @type {(inputs: Bodymap_Region_Elbow_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gomito sinistro`)
};

/**
* | output |
* | --- |
* | "Left elbow" |
*
* @param {Bodymap_Region_Elbow_LInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_elbow_l = /** @type {((inputs?: Bodymap_Region_Elbow_LInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_Elbow_LInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_elbow_l(inputs)
	if (locale === "es-419") return es_419_bodymap_region_elbow_l(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_elbow_l(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_elbow_l(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_elbow_l(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_elbow_l(inputs)
	return en_us2_bodymap_region_elbow_l(inputs)
});
export { bodymap_region_elbow_l as "bodymap.region.elbow_l" }